import * as React from "react";
import TableRow from "@material-ui/core/TableRow/TableRow";
import {createStyles, TableCell, Theme, withStyles, WithStyles} from "@material-ui/core";
import TableHead from "@material-ui/core/TableHead/TableHead";
import Typography from "@material-ui/core/Typography/Typography";
import {datatableConsumer, IDatatableContext} from "../Datatable";
import {connect} from "react-redux";

const styles = (t: Theme) => createStyles({
  row: {
    background: t.palette.background.default,
    minHeight: 48,
  },
  root: {
    display: 'flex',
    alignItems: 'baseline',
    marginBottom: t.spacing.unit / 2
  },
  title: {
    marginRight: t.spacing.unit * 2
  },
  floatLeft: {
    justifyContent: 'flex-start',
  },
  floatRight: {
    justifyContent: 'flex-end',
  }
});

interface IProps extends IDatatableContext,
  ReturnType<typeof dispatch2props>,
  WithStyles<typeof styles>{
  children: any;
  float?: "left" | "right";
}

class DatatableFilters extends React.Component<IProps>{

  render(){
    const { classes, children, float } = this.props;
    return (
      <TableHead>
        <TableRow className={classes.row}>
          <TableCell colSpan={100}>
            <div className={`${classes.root} ${float === "left" ? classes.floatLeft : classes.floatRight}`}>
              <span className={classes.title}>
                <Typography variant='body1'>Filtres</Typography>
              </span>
              {React.Children.map(children, (child: any) => (
                  React.cloneElement(child, {
                    onValueChange: child.props.categories ? this.onUpdateObjectCriteria : this.onUpdateCriteria
                  })
                )
              )}
            </div>
          </TableCell>
        </TableRow>
      </TableHead>
    )
  }

  onUpdateCriteria = (name, value) => {
    const { changeFilter, actions } = this.props;
    changeFilter(actions.updateCriteria, name, value)
  }

  onUpdateObjectCriteria = (obj) => {
    const { changeObjFilter, actions } = this.props;
    changeObjFilter(actions.updateFilterCriteriaByObject, obj)
  }
}

const dispatch2props = dispatch => ({
  changeFilter: (action, name, value) => dispatch(action(name, value)),
  changeObjFilter: (action, obj) => dispatch(action(obj))
});

export default datatableConsumer(connect(null, dispatch2props)(withStyles(styles)(DatatableFilters)))



// WEBPACK FOOTER //
// ./src/shared/Datatable/Filters/DatatableFilters.tsx